import type { UiSkin } from "./skins";

export interface BrandNames {
    optivo: string;
    previoLine1: string;
    previoLine2: string;
    betterHotelLine1: string;
    betterHotelLine2: string;
}

/** App-shell brand label. `line2` (e.g. "RMS by Optivo") is null for skins with no PMS co-brand. */
export interface BrandLabel {
    line1: string;
    line2: string | null;
}

/** Resolves the app-shell brand label, split for two-line display, for the active skin. */
export function resolveBrandLabel(skin: UiSkin, names: BrandNames): BrandLabel {
    if (skin === "previo") return { line1: names.previoLine1, line2: names.previoLine2 };
    if (skin === "better_hotel") return { line1: names.betterHotelLine1, line2: names.betterHotelLine2 };
    return { line1: names.optivo, line2: null };
}

/** Flattens a BrandLabel to a single-line string, for contexts that can't wrap (tab title, tooltips). */
export function brandLabelToString(label: BrandLabel): string {
    return label.line2 ? `${label.line1} ${label.line2}` : label.line1;
}
